module.exports = __webpack_public_path__ + "img/15.652e055d.svg";